import * as React from 'react';

import './styles.scss';
import Icon, { IconsAvailable, IIconProps } from '../Icon';

export interface IAvatarProps {
    /** style to pass */
    style?: React.CSSProperties;
    /** Name to get initials from */
    name?: string | number;
    /** image URL */
    url?: string | null;
    /** avatar size */
    size?: number;
    /** icon size */
    iconsize?: number;
    /** Icon to use instead of avata or name */
    icon?: IconsAvailable;
    /** Props to pass to icon if defined */
    iconProps?: IIconProps;
}

interface IState {
    size: number;
}

/**
 * Displays user avatar with image or user initials automatically parsed from input string. Business type acronymes are excluded but may not be complete.
 */
export default class Avatar extends React.Component<IAvatarProps, IState> {
    static displayName: string = 'Avatar';

    constructor (props: IAvatarProps) {
        super(props);
    }

    render () {
        function getInitials (str: string) {
            let names = str.split(' ');

            const ignore = ['FIE', 'OÜ', 'AS', 'TÜ', 'UÜ', 'MTÜ', 'LTD', 'LTD.', 'Ltd', 'Ltd.', '-', '&'];

            names = names.filter((name: string) => ignore.filter((s: string) => s === name).length <= 0);

            let initials = names[0].substring(0, 1).toUpperCase();
            if (names.length > 1) {
                initials += names[names.length - 1].substring(0, 1).toUpperCase();
            }
            return initials;
        }

        return (
            <span
                className="avatar"
                style={{
                    ...{
                        width: this.props.size ? this.props.size : 50,
                        height: this.props.size ? this.props.size : 50,
                    },
                    ...this.props.style,
                }}
            >
                {this.props.icon ? (
                    <Icon
                        width={this.props.iconsize ? this.props.iconsize / 3 : 50 / 3}
                        height={this.props.iconsize ? this.props.iconsize / 3 : 50 / 3}
                        kind={this.props.icon}
                        {...this.props.iconProps}
                    />
                ) : (
                    <React.Fragment>
                        <span style={{
                            fontSize: this.props.size ? this.props.size / 2.2 : 20,
                            lineHeight: (this.props.size ? this.props.size / 2 : 30) + 'px',
                        }}>
                            {typeof this.props.name === 'number' ? this.props.name : getInitials(this.props.name ? this.props.name : '')}
                        </span>
                        {this.props.url && !!this.props.name && (
                            <img
                                alt={this.props.name.toString()}
                                src={this.props.url}
                            />
                        )}
                    </React.Fragment>
                )}
            </span>
        );
    }
}
